var ShareJsDocLoader = require('./shareJsDocLoader');
var EmptyDocLoader = require('./emptyDocLoader');
var FileSystemDocLoader = require('./fileSystemDocLoader');
var StaticDocLoader = require("./staticDocLoader.js");
var FusionContentDocLoader = require("./fusionContentDocLoader.js");
///////////////
//constructor//
///////////////
var DocumentLoaderFactory = function () {};
module.exports = DocumentLoaderFactory;

//////////
//static//
//////////
DocumentLoaderFactory.getInstance = function(root, dataManager, config, userController) {
    return DocumentLoaderFactory._init(root, dataManager, config, userController);
};

///////////
//private//
///////////
DocumentLoaderFactory._init = function (root, dataManager, config, userController) {
    if (config.type === 'ShareJs') {
        if (DocumentLoaderFactory._isValidConfig(config)) {
            return new ShareJsDocLoader(root, dataManager, config, userController);
        } else {
            throw new Error('Configuration error: Invalid ShareJs configuration.');
        }
    } else if (config.type === 'Empty') {
        return new EmptyDocLoader(root, dataManager, config);
    } else if (config.type === 'FileSystem') {
        return new FileSystemDocLoader(root, dataManager, config);
    } else if (config.type === 'Static') {
        return new StaticDocLoader(root, dataManager, config);
    } else if (config.type === 'FusionContent') {
        return new FusionContentDocLoader(root, dataManager, config);
    } else
    throw new Error('Configuration error: Incorrect type of ColabDocStoreConfig. For now, only \'ShareJs\', \'FileSystem\', \'Empty\' or \'Preload\'are supported.');
};

DocumentLoaderFactory._isValidConfig = function(config) {
    return true;
};
